import Layout from './Layout';
import Spinner from '../elements/Spinner';
import styles from 'styles/components/common/layout/LoadingLayout.module.scss';

const LoadingLayout = () => {
  return (
    <Layout>
      <div className={styles.wrapper}>
        <Spinner />
      </div>
    </Layout>
  );
};

export default LoadingLayout;
